import React, { ReactElement } from "react";

import { Container, StyledMap } from "./MapSection.styled";
import MapSectionProps from "./MapSectionProps";

const MapSection = ({
    identifier,
    latitude,
    longitude,
    zoom = 15,
    heading = "",
    disableDefaultUI = true,
    zoomControl = true,
    className,
    anchorName,
}: MapSectionProps): ReactElement => {
    return latitude && longitude ? (
        <Container
            key={identifier || `MapSectionContent`}
            id={anchorName || identifier}
            className={className}
        >
            <StyledMap
                latitude={latitude}
                longitude={longitude}
                zoom={zoom}
                title={heading}
                disableDefaultUI={disableDefaultUI}
                zoomControl={zoomControl}
            />
        </Container>
    ) : (
        <></>
    );
};

export default React.memo(MapSection);
